/* global Swiper */

export default{
  init() {
    // TODO: update key feature preview image when slide changes? (to confirm)
    const partialImageSliders = $('.cpt-room-features');
    partialImageSliders.each(function() {
      const swiperContainer = $(this).find('.swiper-container').get(0);

      const prevBtn = $(this).find('.swiper-navigation .prev').get(0);
      const nextBtn = $(this).find('.swiper-navigation .next').get(0);

      if (swiperContainer) {
        new Swiper(swiperContainer, {
          slidesPerView: 1.5,
          spaceBetween: 16,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
          breakpoints: {
            425: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 4,
            },
          },
        });
      }
    });
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleCptRoom.js